import { render, staticRenderFns } from "./NightSwitch.vue?vue&type=template&id=4f1ecc3b"
import script from "./NightSwitch.vue?vue&type=script&lang=js"
export * from "./NightSwitch.vue?vue&type=script&lang=js"
import style0 from "./NightSwitch.vue?vue&type=style&index=0&id=4f1ecc3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports